(function () {
    'use strict';

    angular
        .module('partners')
        .controller('VirtualFairWhatsAppReminderController', VirtualFairWhatsAppReminderController)

    VirtualFairWhatsAppReminderController.$inject = ['VirtualFairService'];

    function VirtualFairWhatsAppReminderController(VirtualFairService) {
        var vm = this;
        vm.getVirtualFairs = getVirtualFairs;
        vm.reminder = reminder;
        vm.disabledReminder = false;

        vm.virtualFairs = [];

        function getVirtualFairs() {
            VirtualFairService.getVirtualFairsWhatsAppReminder().then((response) => {
               vm.virtualFairs = response.data;
            });
        }

        function reminder(id, template) {
            if (! vm.disabledReminder) {
                vm.disabledReminder = true;

                VirtualFairService.sendWhatsAppReminder({
                    virtual_fair_id: id,
                    template: template,
                }).then((response) => {
                   vm.disabledReminder = false;
                });

            }
        }

        vm.getVirtualFairs();
    }

})();
